import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import { ErrorBoundary } from './design-system';

import('react-ga4').then(module => {
    const ReactGA = module.default;
    ReactGA.initialize('G-WE4NS27YSV');
}).catch(() => {
});

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            staleTime: 5 * 60 * 1000,
            gcTime: 30 * 60 * 1000,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode>
    <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </ErrorBoundary>
</React.StrictMode>);
